import React from 'react';

const footerLinks = {
  Platform: [
    'People & company search',
    'CRM & CSV Enrichment',
    'Email finder',
    'Intent data',
    'Chrome extension',
    'Find mobile numbers',
    'Domain search',
    'Integrations',
    'API',
  ],
  'Use case': [
    'For Lead Generation agencies',
    'For Sales Leader',
    'For Founders',
    'For RevOps',
  ],
  Alternatives: [
    'Director Discovery VS ZoomInfo',
    'Director Discovery VS Apollo',
    'Director Discovery VS Cognism',
    'Director Discovery VS Lusha',
  ],
  Resources: [
    'Helpdesk',
    'API documentation',
    'Contact & companies',
    'Buy Email Lists',
    'Technologies Customers',
    'List of Companies',
    'Pricing',
    'Referral Program',
    'Sales Hub',
  ],
  Legal: [
    'Opt-Out',
    'Trust Center',
    'Privacy Policy',
    'Terms of Service',
    'Do not sell my data',
  ],
};

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 mb-12">
          {/* Brand col */}
          <div className="col-span-2 sm:col-span-3 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 bg-indigo-600 rounded-md flex items-center justify-center">
                <span className="text-white text-xs font-bold">P</span>
              </div>
              <span className="text-gray-900 font-bold text-lg tracking-tight">Director Discovery</span>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed mb-4">
              Find verified emails & phone numbers for outreach. 280M+ leads database.
            </p>
            <div className="flex gap-3">
              {[
                { label: 'YT', color: 'bg-red-100 text-red-600' },
                { label: 'IG', color: 'bg-pink-100 text-pink-600' },
                { label: '𝕏', color: 'bg-gray-100 text-gray-700' },
              ].map((s) => (
                <a key={s.label} href="#" className={`w-8 h-8 rounded-full ${s.color} flex items-center justify-center text-xs font-bold hover:opacity-80 transition-opacity`}>
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h4 className="text-xs font-bold text-gray-800 uppercase tracking-wider mb-3">{section}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link}>
                    <a href="#" className="text-sm text-gray-500 hover:text-indigo-600 transition-colors">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">2026 © Director Discovery. All rights reserved.</p>
          <div className="flex items-center gap-3 flex-wrap justify-center">
            {['G2 Leader', 'G2 High Performer', 'Clay Certified', 'Most Loved'].map((badge) => (
              <div key={badge} className="text-xs text-gray-400 bg-white border border-gray-200 px-3 py-1 rounded-full font-medium">
                {badge}
              </div>
            ))}
          </div>
          <a href="#" className="text-sm text-indigo-600 hover:underline font-medium">
            Read customer reviews on G2 →
          </a>
        </div>
      </div>
    </footer>
  );
}
